export default __webpack_public_path__ + "static/media/mail.b8107c75.png";